import React, { useState, useEffect } from "react";
import classnames from "classnames";
import "./InputField.scss";

import FormMessage from "../FormMessage/FormMessage";
import { SpellChecker } from "./SpellChecker";

const InputField = ({
  placeholder,
  label,
  className,
  notes,
  warnings,
  errors,
  forceError,
  showNoteLabel,
  limit,
  onChange,
  initial,
  value,
  disabled,
  readonly,
  type,
  name,
  htmlType,
  spellChecker
}) => {
  const [showNote, setShowNote] = useState(false);
  const [val, setVal] = useState(initial);

  const spellCheckerProps = spellChecker ? spellChecker(name) : undefined;
  const spellCheckerErrors = spellCheckerProps?.errors;
  const shouldDisplaySpellErrors =
    spellCheckerErrors && spellCheckerErrors.length !== 0;

  const handleChange = e => {
    setVal(e.target.value);
    onChange(e);
  };

  //const getValue = () => (value != undefined ? value : val) || "";
  const getValue = () => val || "";
  const left = limit && limit - getValue().length;

  const hasError = () => forceError || errors.length != 0;

  const showHeader = limit || label;

  useEffect(() => {
    setVal(value);
  }, [value]);

  return (
    <div
      className={classnames("input-field", className, {
        errors: hasError(),
        warnings: !hasError() && warnings.length != 0,
        disabled: disabled
      })}
    >
      {showHeader && (
        <div className="input-field__header">
          <div className="input-field__title">{label}</div>
          {limit && (
            <div
              className={classnames("input-field__count", { red: left <= 5 })}
            >
              Осталось символов: {left}
            </div>
          )}
        </div>
      )}
      <div className="input-field__input">
        {type == "text" ? (
          <textarea
            placeholder={placeholder}
            onChange={handleChange}
            value={getValue()}
            disabled={disabled}
            readOnly={readonly}
            name={name}
          />
        ) : (
          <input
            placeholder={placeholder}
            onChange={handleChange}
            value={getValue()}
            disabled={disabled}
            readOnly={readonly}
            name={name}
            type={htmlType}
          />
        )}
      </div>

      {notes.length != 0 &&
        (!showNoteLabel || showNote ? (
          <FormMessage messages={notes} />
        ) : (
          <span
            className="input-field__show-note"
            onClick={() => setShowNote(true)}
          >
            Показать метку
          </span>
        ))}

      <FormMessage messages={errors} color="error" />
      <FormMessage messages={warnings} color="warn" />
      {shouldDisplaySpellErrors && (
        <SpellChecker
          name={name || ""}
          text={value || ""}
          onTextChange={onChange}
          spellCheckerProps={spellCheckerProps}
        />
      )}
    </div>
  );
};

InputField.defaultProps = {
  notes: "",
  warnings: "",
  errors: ""
};

export default InputField;
